import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {GeneratedReportDataI} from './reports/pages/report-generator/report-generator-types';

@Injectable({
    providedIn: 'root'
})
export class SubjectsService {
    updateAccountingPoint$: Subject<any> = new Subject<any>();
    onCloseAccountingPointModal$: Subject<boolean> = new Subject<boolean>();
    soundAlertActive$ = new BehaviorSubject(false);

    reportGeneratorData$ = new BehaviorSubject<GeneratedReportDataI>(null);
}
